import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'ד"ר איה כהן',
  role: 'מנכ"לית ומייסדת',
  img: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400'
}, {
  name: "פרופ' יונתן לוי",
  role: 'מדען ראשי',
  img: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?auto=format&fit=crop&q=80&w=400'
}, {
  name: 'מאיה שטרן',
  role: 'סמנכ"לית הנדסה',
  img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=400'
}];
export function Team() {
  return <section id="team" className="py-24 relative z-10" data-id="element-178">
      <div className="max-w-7xl mx-auto px-6" data-id="element-179">
        <div className="text-center mb-16" data-id="element-180">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-181">
            המוחות{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-fuchsia-400" data-id="element-182">
              מאחורי המשימה
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-183">
            צוות של מומחים בעלי שם עולמי מאקדמיות וסוכנויות חלל מובילות.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-184">
          {team.map((member, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="flex flex-col items-center text-center group" data-id="element-185">
              <div className="relative w-48 h-48 mb-6" data-id="element-186">
                <div className="absolute inset-0 rounded-full border-2 border-dashed border-violet-500/30 group-hover:rotate-180 transition-transform duration-1000" data-id="element-187" />
                <div className="absolute inset-2 rounded-full border border-cyan-500/50 group-hover:-rotate-90 transition-transform duration-700" data-id="element-188" />
                <div className="absolute inset-4 rounded-full overflow-hidden border-2 border-white/10 group-hover:border-white/50 transition-colors" data-id="element-189">
                  <img src={member.img} alt={member.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-190" />
                </div>
                {/* Glow */}
                <div className="absolute inset-0 rounded-full shadow-[0_0_30px_rgba(139,92,246,0)] group-hover:shadow-[0_0_40px_rgba(139,92,246,0.4)] transition-shadow duration-500 pointer-events-none" data-id="element-191" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-1" data-id="element-192">
                {member.name}
              </h3>
              <p className="text-cyan-400 font-medium" data-id="element-193">{member.role}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}